// Declare swiperInstances globally
let swiperInstances = [];

function reinitializeSwipers() {
  // Destroy existing swiper instances
  swiperInstances.forEach((swiper, index) => {
    if (swiper && swiper.destroy) {
      swiper.destroy(true, true);
      console.log(`Swiper instance ${index} destroyed.`);
    }
  });
  swiperInstances = [];

  // Reinitialize swipers after a short delay
  setTimeout(() => {
    const swiperSwatches = document.querySelectorAll('.swiper-js-swatches');

    swiperSwatches.forEach((element, index) => {
      const el = element.querySelector('.swiper'),
        navNext = element.querySelector('.swiper-button-next'),
        navPrev = element.querySelector('.swiper-button-prev');

      if (!el) {
        console.warn(`Swiper swatches element not found for swatch ${index}`);
        return;
      }

      const swiperOptions = {
        slidesPerView: 5,
        spaceBetween: 0,
        loop: false,
        centerInsufficientSlides: true,
        breakpoints: {
          767: { slidesPerView: 3 },
          1024: { slidesPerView: 5 },
          1270: { slidesPerView: 5 },
        },
        navigation: {
          nextEl: navNext,
          prevEl: navPrev,
        },
      };

      const swiper = new Swiper(el, swiperOptions);
      swiperInstances.push(swiper);
      //console.log(`Swiper swatches instance ${index} reinitialized.`);
    });
  }, 1000); // Add delay to ensure DOM is ready
}

// Ensure DOM is loaded before initializing
document.addEventListener('DOMContentLoaded', function () {
  reinitializeSwipers();


});

// Hooking into Alpine.js
document.addEventListener('alpine:init', () => {
  Alpine.data('swiperHandler', () => ({
    init() {
      // This runs when Alpine initializes
      reinitializeSwipers();
    },

  }));
});
